import React from 'react';
import Header from "./components/header";

import {store} from "./app/store";

import {fetchAllMoviesAsync1} from "./app/reducers/searchSlice";
import {fetchGenresAsync} from "./app/reducers/genresSlice";

import PagesRouter from "./routes/PagesRouter";

store.dispatch(fetchAllMoviesAsync1(1));
store.dispatch(fetchGenresAsync());

function App() {
  return (
    <div className="App">

        <Header />

        <PagesRouter />

    </div>
  );
}

export default App;
